import { Collapse, Divider } from 'antd';
import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ButtonSecondaryMedium from '../../common/ButtonSecondary/ButtonSecondaryMedium';
import LeftMenuDesign from '../../common/LeftMenuDesign/LeftMenuDesign';
import { Icon } from '../../icon/icon';
import './RightApplyDoorChangesToAll.scss';
import { CSSTransition } from 'react-transition-group';
import DropdownFilter from '../../common/DropdownFilter/DropdownFilter';
import ButtonIconOutlineMedium from '../../common/ButtonIconOutline/ButtonIconOutlineMedium';
import { useParams } from 'react-router-dom';
import { DesignerPageContext } from '../../../pages/DesignerPage/DesignerPage';
import callApi from '../../../utils/api/callAPI';
import RightMenuDesign from '../../house/RightMenuDesign/RightMenuDesign';
import { getValueFromString } from '../../../utils/data/getValue.utils';
import { useTranslation } from 'react-i18next';
import CardProduct from '../../card/CardProduct/CardProduct';
import CardProductClick from '../../card/CardProduct/CardProductClick';
// import {
//   fetchDoorHandles,
//   fetchGroupDoor,
// } from '../../../store/actions/door.handle.action';
import Chip from '../../common/Chip/Chip';
const { Panel } = Collapse;

const RightApplyDoorChangesToAll = ({ open, onClose, title }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { products } = useSelector(state => state.product);

  const {
    sceneManager,
    selectedModel,
    insideLoaderRef,
    setTick,
    currentCabinet,
    groupDoorId,
    setGroupDoorId,
    currentProduct,
  } = useContext(DesignerPageContext);

  // const [currentProduct, setCurrentProduct] = useState();
  const [currentModuleType, setCurrentModuleType] = useState();

  const [loading, setLoading] = useState(false);
  const { door, groupDoor } = useSelector(state => state.doorAndHandle);

  const { type } = useParams();

  useEffect(() => {
    if (!selectedModel?.uuid || !sceneManager?.cabinetManager) {
      // setCurrentProduct(null);
      return;
    }
    const module = sceneManager.cabinetManager.getModuleByGltfUuid(
      selectedModel.uuid
    );
    // setCurrentProduct(module?.moduleData.product_type_id);
    setCurrentModuleType(module?.moduleType);
  }, [selectedModel, sceneManager]);

  // useEffect(() => {
  //   if (!currentProduct || !groupDoorId) return;

  //   dispatch(
  //     fetchDoorHandles({
  //       product_type: currentProduct,
  //       door_type: 'HINGED',
  //       group_type: groupDoorId,
  //     })
  //   );
  // }, [currentProduct, groupDoorId]);

  const handleCardClick = (md, groupKey) => {
    if (!insideLoaderRef?.current?.applyDoorChangesToAll) {
      console.error('applyDoorChangesToAll function not found');
      return;
    }

    if (!currentCabinet) {
      console.error('Current cabinet not found');
      return;
    }

    const items = door?.data?.[groupKey] || [];
    const ids = items.map(x => x?.id).filter(Boolean);

    // Truyền md, currentCabinet và currentDoorId vào hàm
    insideLoaderRef.current.applyDoorChangesToAll(
      md,
      currentCabinet,
      ids,
      currentModuleType
    );

    // Trigger re-render nếu cần
    setTick?.(prev => prev + 1);

    setTimeout(async () => {
      await sceneManager?.calculateTotalCost?.({});

      sceneManager?.handleDrawBorder();
      sceneManager?.handleDrawBorderSelectedModule(selectedModel, true);
    }, 500);

    // Đóng menu sau khi apply
    // onClose?.();
  };

  return (
    <RightMenuDesign
      open={open}
      classNames={{
        content: 'flex flex-col p-4 items-start gap-8 grow self-stretch',
        root: 'top-84',
      }}
      styles={{ content: { backgroundColor: '#F7F7F7' } }}
      header={
        <>
          <span className="text-title-large">{t('Edit Doors')}</span>
          <span
            className="w-24 h-24 flex"
            style={{ cursor: 'pointer' }}
            onClick={onClose}
          >
            <Icon.ICClose />
          </span>
        </>
      }
      content={
        <>
          <div className="flex items-center justify-start self-stretch relative top-0 left-0 right-0 px-16 py-8 bg-fills-white">
            <div className="flex items-start gap-8 self-stretch">
              {groupDoor.data?.map(item => (
                <Chip
                  label={
                    <span className="text-label-medium-emphasized">
                      {item.label}
                    </span>
                  }
                  active={item.value === groupDoorId}
                  onClick={() => setGroupDoorId(item.value)}
                />
              ))}
            </div>
          </div>
          <div className="flex flex-col p-4 gap-8 self-stretch items-start align-content-start">
            <Collapse
              expandIcon={({ isActive }) => (
                <span className="w-16 h-16 flex">
                  {isActive ? <Icon.ICExpandMore /> : <Icon.ICExpandLess />}
                </span>
              )}
              defaultActiveKey={['1', '2', '3']}
              onChange={() => {}}
              className="grow flex self-stretch overflow-auto custom-collapse-no-padding [&_.ant-collapse-content-active]:!bg-transparent [&_.ant-collapse-item]:!border-none"
              items={[
                {
                  key: '1',
                  label: (
                    <span className="text-title-medium">
                      {t('With handle')}
                    </span>
                  ),
                  children: (
                    <div className="flex !p-0 items-start align-content-start gap-2 grow self-stretch flex-wrap">
                      {door?.data?.door_with_handle?.map((md, i) => {
                        // {listDoor.map((md, i) => {
                        const name = getValueFromString(md.name);
                        const description = getValueFromString(
                          md.description ?? ''
                        );
                        return (
                          <CardProductClick
                            key={i}
                            md={md}
                            title={name}
                            description1={md.size}
                            description2={description}
                            // description2={
                            //   <span className="text-label-small">
                            //     {md.price?.toLocaleString('vi-VN', {
                            //       style: 'currency',
                            //       currency: 'VND',
                            //     })}
                            //   </span>
                            // }
                            moduleType={'moduleType'}
                            onClick={() =>
                              handleCardClick(md, 'door_with_handle')
                            }
                          />
                        );
                      })}
                    </div>
                  ),
                },
                {
                  key: '2',
                  label: (
                    <span className="text-title-medium">
                      {t('Without handle')}
                    </span>
                  ),
                  children: (
                    <div className="flex !p-0 items-start align-content-start gap-2 grow self-stretch flex-wrap">
                      {door?.data?.door_without_handle?.map((md, i) => {
                        // {listDoor45.map((md, i) => {
                        const name = getValueFromString(md.name);
                        const description = getValueFromString(
                          md.description ?? ''
                        );
                        return (
                          <CardProductClick
                            key={i}
                            md={md}
                            title={name}
                            description1={md.size}
                            description2={description}
                            // description2={
                            //   <span className="text-label-small">
                            //     {md.price?.toLocaleString('vi-VN', {
                            //       style: 'currency',
                            //       currency: 'VND',
                            //     })}
                            //   </span>
                            // }
                            moduleType={'moduleType'}
                            onClick={() =>
                              handleCardClick(md, 'door_without_handle')
                            }
                          />
                        );
                      })}
                    </div>
                  ),
                },
              ].map(item => ({
                ...item,
                onKeyDown: e => {
                  e.stopPropagation();
                },
              }))}
            />
          </div>
        </>
      }
    />
  );
};

export default RightApplyDoorChangesToAll;
